import { schema } from "normalizr";

const project = new schema.Entity("projects");
const arrayOfProjects = [project];

export { project, arrayOfProjects };
